import { RoleEnum } from '../../models/Index';

export const CURRENT_CUSTOMER_UUID_KEY = 'currentCustomerUuid';

// The tenant_id of the token is the authority for the customer context. The value in localStorage is only a
// cache for the superuser customer switch and must never outlive the session or override another tenant.

function getStoredCustomerUuid(): string | null {
    return localStorage.getItem(CURRENT_CUSTOMER_UUID_KEY);
}

function storeCustomerUuid(customerUuid: string) {
    localStorage.setItem(CURRENT_CUSTOMER_UUID_KEY, customerUuid);
}

function clearStoredCustomerUuid() {
    localStorage.removeItem(CURRENT_CUSTOMER_UUID_KEY);
}

/**
 * Returns the customer to work with. A stored customer is only honoured if it matches the tenant or the login is a
 * superuser; otherwise it is discarded. Without known roles the stored value is left untouched.
 */
function resolveCustomerUuid(tenantId: string, roles?: RoleEnum[]): string {
    const storedCustomerUuid = getStoredCustomerUuid();
    if (!storedCustomerUuid || storedCustomerUuid === tenantId) {
        return tenantId;
    }
    if (!roles) {
        return tenantId;
    }
    if (roles.includes(RoleEnum.SUPER_USER)) {
        return storedCustomerUuid;
    }
    clearStoredCustomerUuid();
    return tenantId;
}

const CustomerContextService = {
    getStoredCustomerUuid,
    storeCustomerUuid,
    clearStoredCustomerUuid,
    resolveCustomerUuid,
};

export default CustomerContextService;
